export default __webpack_public_path__ + "static/media/RIDE1.2e5ee5e9.jpg";